<div class="app-container">
  <div class="container-card">
    <router-outlet></router-outlet>
  </div>
</div>

